import React, { Component } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import ReactToPrint, { PrintContextConsumer } from "react-to-print";

export default class DriverWageDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: props.data || null,
      fromDate:props.fromDate || null,
      toDate:props.toDate || null,
      isCalculateLoading: false,
      isDownloadLoadingPdf: false,
      user_company : window.user_company
    }
  }

  handleAfterPrint = () => {
    $('.printDriverName').addClass('d-none');
  };

  handleCalculateWageButtonClicked() {
    this.setState({
      isCalculateLoading: true
    }, () => {
      console.log(this.state.isCalculateLoading);
        this.calculateWage().then(() => {
          this.setState({
            isCalculateLoading: false
          });
        });
    });
  }

  handleApproveWageButtonClicked() {
    this.approveWage();
  }

  handleSetWageAsPaidButtonClicked() {
    this.setWageAsPaid();
  }

   setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  setWageAsPaid() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/set-as-paid',
        data: {
          api_token: window.api_token,
          wage_paid_reference: $(
            '#driver-wage-'+this.state.data.id+' [name=wage_paid_reference]').val()
        },
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
      });
  }

  calculateWage() {
    var that = this;
     return $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/calculate/'+this.state.fromDate+'/'+this.state.toDate,
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(calculatedWageJson) {
        that.setState({data: calculatedWageJson, isLoading: false});
      });
  }

  approveWage() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/approve',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
      });
  }

  renderDriverInvoice = (ref) => {
    let BreakdownItems = [];
    let driverInvoiceName = document.getElementById('driver-wage-details-modal-label').innerText;
    var that = this;
    let finalTotal = 0;
    if (this.state.data.breakdown &&
      (this.state.data.breakdown.length > 0)) {

      let i = 0;
      let acvTotal=0;
      let acvtruckTotal=0;
      let bvlTotal=0;
      let g4Total=0;
      let cndTotal=0;
      let sccdTotal=0;
      let miles = 0;
      this.state.data.breakdown.forEach(function(breakdownItem) {
        // BreakdownItems.push(<div key={that.state.data.id+'-'+i++} className="row wages-cell-border">
        //   <div className="col-md-2">
        //     {breakdownItem.date}
        //   </div>
        //   <div className="col-md-2">
        //     {breakdownItem.type}
        //   </div>
        //   <div className="col-md-2">
        //     {breakdownItem.category}
        //   </div>
        //   <div className="col-md-1">
        //     {breakdownItem.company}
        //   </div>
        //   <div className="col-md-3">
        //     {breakdownItem.description}
        //   </div>
        //   <div className={'col-md-2 '+breakdownItem.type+'-debit'}>
        //     {breakdownItem.formatted_currency_string}
        //   </div>
        // </div>);
        
        if(breakdownItem.company == "ACV"){
          if(breakdownItem.category == "debit"){
            acvTotal = (acvTotal) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            acvTotal = (acvTotal) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if(breakdownItem.company == "BVL"){
          if(breakdownItem.category == "debit"){
            bvlTotal = (bvlTotal) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            bvlTotal = (bvlTotal) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if(breakdownItem.company == "G4"){
          if(breakdownItem.category == "debit"){
            g4Total = (g4Total) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            g4Total = (g4Total) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if(breakdownItem.company == "CND"){
          if(breakdownItem.category == "debit"){
            cndTotal = (cndTotal) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            cndTotal = (cndTotal) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if(breakdownItem.company == "SCCD"){
          if(breakdownItem.category == "debit"){
            sccdTotal = (sccdTotal) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            sccdTotal = (sccdTotal) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if(breakdownItem.company == "ACV-TRUCK"){
          if(breakdownItem.category == "debit"){
            acvtruckTotal = (acvtruckTotal) - parseFloat(breakdownItem.formatted_currency_string);
          }else{
            acvtruckTotal = (acvtruckTotal) + parseFloat(breakdownItem.formatted_currency_string);
          }
        }
        if (breakdownItem.miles == '') {
          miles = parseFloat(miles) + parseFloat(0.00);
        } else {
          miles = parseFloat(miles) + parseFloat(breakdownItem.miles);
        }
        
        BreakdownItems.push(<tr key={that.state.data.id+'-'+i++} className={(breakdownItem.category == 'debit') ? 'debit-red wages-cell-border' : 'credit wages-cell-border'}>
        <td>{breakdownItem.date}</td>
        <td>{breakdownItem.type}</td>
        <td>{breakdownItem.category}</td>
        <td>{breakdownItem.company}</td>
        <td>{breakdownItem.description}</td>
        <td>{breakdownItem.miles}</td>
        {(breakdownItem.company == "ACV") ? 
          <td className={breakdownItem.type+'-debit ACV'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
        {(breakdownItem.company == "ACV-TRUCK") ? 
          <td className={breakdownItem.type+'-debit ACV-TRUCK'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
        {(breakdownItem.company == "BVL") ? 
          <td className={breakdownItem.type+'-debit BVL'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
        {(breakdownItem.company == "G4") ? 
          <td className={breakdownItem.type+'-debit G4'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
        {(breakdownItem.company == "CND") ? 
          <td className={breakdownItem.type+'-debit CND'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
        {(breakdownItem.company == "SCCD") ? 
          <td className={breakdownItem.type+'-debit SCCD'}>&pound;{breakdownItem.formatted_currency_string}</td>
        : <td></td>}
      </tr>);
      });
      BreakdownItems.push(
        <tr key={that.state.data.id+'-'+i++}>
          <td colSpan="5"><strong>Total</strong></td>
          <td>{miles.toFixed(2).toString()}</td>
          <td>&pound;{acvTotal.toFixed(2).toString()}</td>
          <td>&pound;{acvtruckTotal.toFixed(2).toString()}</td>
          <td>&pound;{bvlTotal.toFixed(2).toString()}</td>
          <td>&pound;{g4Total.toFixed(2).toString()}</td>
          <td>&pound;{cndTotal.toFixed(2).toString()}</td>
          <td>&pound;{sccdTotal.toFixed(2).toString()}</td>
        </tr>
      );
      finalTotal = (acvTotal) +(acvtruckTotal)+ (bvlTotal) + (g4Total) + (cndTotal) + (sccdTotal);
    }

    return (
      <div className="text-left" id={'driver-wage-'+this.state.data.id}>

        <div className="row">
          <div className="col-md-6">
            <button
              className="btn btn-lg btn-primary"
              disabled={this.state.isCalculateLoading}
              onClick={(e) => this.handleCalculateWageButtonClicked()}
              >
              <i className={(this.state.isCalculateLoading ? "fa fa-spinner fa-spin" : "fa fa-calculator")}></i> {this.state.user_company == '2' ? 'Calculate Activity Confirmation' : 'Calculate Invoice'}
            </button>

            <button
              className="btn btn-lg btn-secondary ml-2"
              disabled={this.state.isDownloadLoadingPdf}
              onClick={(e) => {
                const printDriverNameElement = document.querySelector('#printDriverName');
                if (printDriverNameElement) {
                  this.setState({ isDownloadLoadingPdf: true });
                  printDriverNameElement.classList.remove("d-none");
                  this.handlePrintPdfViJsonButtonClicked();
                  // document.getElementById('driver-wage-details-print').click();
                }
              }}
              >
              <i className={(this.state.isDownloadLoadingPdf ? "fa fa-spinner fa-spin" : "fa fa-download")}></i> Download
              </button>
          </div>
        </div>

        {(this.state.data.calculated == 0) ?
            <p>Not calculated yet</p>
        :

      <div>
      
       {(this.state.data.breakdown && this.state.data.breakdown.length > 0) ?
         <div className="wage-details-calculated-wage-breakdown-container" ref={ref}>
          <div className="row">
            <div className="col-md-12">
              <center className="printDriverName d-none" id="printDriverName">{driverInvoiceName}</center>
              <h1>{this.state.user_company == '2' ? 'Activity Confirmation' : 'Invoice Details'}</h1>
              <div className="row">
                <table className="driver-wages-tbl">
                  <thead>
                    <tr>
                      <th>date</th>
                      <th>type</th>
                      <th>category</th>
                      <th>company</th>
                      <th>description</th>
                      <th>Miles</th>
                      <th>ACV</th>
                      <th>ACV-TRUCK</th>
                      <th>BVL</th>
                      <th>G4</th>
                      <th>CND</th>
                      <th>SCCD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {BreakdownItems}
                  </tbody>
                </table>
              </div>
              <h3 className="wage-total-payable-container">Total Amount Payable:
                <i className="fa fa-pound-sign"></i>
              <span>
                {/* {(this.state.data.wage_total_payable_in_pence / 100).toFixed(2)} */}
                {/*(finalTotal < 0) ? '0.00' : finalTotal.toFixed(2).toString()*/}
                {finalTotal.toFixed(2).toString()}
              </span>
              </h3>
            </div>
          </div>
        </div>
         :
         ''
       }

       <div className="row">
          <div className="col-md-4">
             <div className="wage-details-wage-approval-status-container">
              {(this.state.data.accountant_approved == 0) ?
                <p>
                  This Invoice is not approved by an accountant.<br />
                  <button className="btn btn-lg btn-dark"
              onClick={(e) => {this.handleApproveWageButtonClicked()}}>
                    <i className="fa fa-check"></i> Click to Approve
                  </button>
                </p>
             :
              <button className="btn btn-lg btn-success">
              <i className="fa fa-check"></i> Accountant Approved
              </button>
            }
              </div>
          </div>
          <div className="col-md-4">
            <div className="wage-details-wage-approval-status-container">
              {/* REJECTED */}
              {this.state.data.driver_approved === 0 && this.state.data.driver_not_approved_reason ? (
                <div>
                  <button className="btn btn-lg btn-danger">
                    <i className="fa fa-times"></i> Driver Rejected
                  </button>

                  <span className="alert-danger reason-block">
                    Declined Driver Reason : {this.state.data.driver_not_approved_reason}
                  </span>
                </div>
              ) : null}

              {/* APPROVED */}
              {this.state.data.driver_approved === 1 ? (
                <div>
                  <button className="btn btn-lg btn-success">
                    <i className="fa fa-check"></i> Driver Approved
                  </button>

                  {this.state.data.driver_approved_reason ? (
                    <span className="alert-info reason-block">
                      Approved Driver Reason : {this.state.data.driver_approved_reason}
                    </span>
                  ) : null}
                </div>
              ) : null}

              {/* PENDING / DEFAULT */}
              {(this.state.data.driver_approved === null ||
                (this.state.data.driver_approved === 0 && !this.state.data.driver_not_approved_reason)) ? (
                <p>This invoice is not yet processed by the driver.</p>
              ) : null}

            </div>
          </div>
          <div className="col-md-4">
            <div className="wage-details-wage-approval-status-container">
             {(this.state.data.driver_approved == 1 &&
               this.state.data.accountant_approved == 1) ?

               (this.state.data.wage_paid == 0) ?
               <p>
               <input type="text"
                name="wage_paid_reference" placeholder="Invoice paid reference"
                className="form-control form-control-lg"
                 />
               <button className="btn btn-lg btn-primary"
               onClick={(e) => {this.handleSetWageAsPaidButtonClicked()}}
               >
                <i className="fa fa-double-check"></i> Set DriverInvoice as paid
                </button>
               </p>
               :
               <p>
                  <button className="btn btn-lg btn-success">
                    <i className="fa fa-check-double"></i> Driver Invoice Paid
                  </button>
               <input type="text"
                name="wage_paid_reference" value={this.state.data.wage_paid_reference}
                 placeholder="invoice paid reference"
                className="form-control form-control-lg"
                 />
                </p>

               :
               <strong>Waiting for Driver Approval</strong>
             }
            </div>
          </div>
        </div>

      </div>
    }
      </div>
    );
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    return this.componentRef;
  };

  handleDriverApproveWageButtonClicked() {
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/force-as-driver/approve',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function(wageJson) {
        that.setState({data: wageJson, isLoading: false});
        //auto refresh selected month week boxes
        if(that.state.data.driver_wage_account_id, that.state.data.calendar_month, that.state.data.calendar_year){
          that.props.getDriverWagesForMonth(that.state.data.calendar_month, that.state.data.calendar_year,true);
        }
      });
  }

  handleMailDriverNowButtonClicked(){
    var that = this;
      $.ajax({
        url: '/api/v1/portal/drivers/wage-accounts/'+
              this.state.data.driver_wage_account_id+
             '/wage/'+this.state.data.id+'/send-instant-mail',
        data: {api_token: window.api_token},
        cache: false,
        method: 'post',
      })
      .done(function() {
        alert('Send mail now ... 📨');
      });
  }

  async handlePrintPdfViJsonButtonClickedOld(){
    const el = this.componentRef;
    if (!el) return;
    try {
      const canvas = await html2canvas(el, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 10;
      const pdfWidth = pageWidth - margin * 2;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      let heightLeft = pdfHeight;
      let position = 0;
      
      doc.addImage(imgData, 'JPEG', margin, margin, pdfWidth, pdfHeight);
      
      while (heightLeft >= pageHeight - margin * 2) {
        position = heightLeft - pageHeight;
        doc.addPage();
        doc.addImage(imgData, 'JPEG', margin, -position + margin, pdfWidth, pdfHeight);
        heightLeft -= pageHeight - margin * 2;
      }
      
      const filename = (document.getElementById('driver-wage-details-modal-label')?.innerText || 'driver-invoice') + '.pdf';
      doc.save(filename);
    } catch (err) {
      console.error(err);
      const printDriverNameElement = document.querySelector('#printDriverName');
      if (printDriverNameElement) printDriverNameElement.classList.remove('d-none');
      document.getElementById('driver-wage-details-print')?.click();
    }
    this.setState({ isDownloadLoadingPdf: false });
  }

  async handlePrintPdfViJsonButtonClicked(){
  const el = this.componentRef;
  if (!el) return;
  try {
    // allow the DOM changes (e.g. removing d-none) to repaint before taking the snapshot
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => setTimeout(resolve, 250));

    // capture with a white background to avoid transparent/blank results, and useCORS for external assets
    const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
    const imgData = canvas.toDataURL('image/png');
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 10;
    const pdfWidth = pageWidth - margin * 2;
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    // calculate how many pages are needed and draw each page offset correctly
    const printableHeight = pageHeight - margin * 2;
    const totalPages = Math.ceil(pdfHeight / printableHeight);

    doc.addImage(imgData, 'PNG', margin, margin, pdfWidth, pdfHeight);

    for (let i = 1; i < totalPages; i++) {
      const yOffset = -(printableHeight * i) + margin;
      doc.addPage();
      doc.addImage(imgData, 'PNG', margin, yOffset, pdfWidth, pdfHeight);
    }

    const filename = (document.getElementById('driver-wage-details-modal-label')?.innerText || 'driver-invoice') + '.pdf';
    doc.save(filename);
  } catch (err) {
    console.error(err);
    const printDriverNameElement = document.querySelector('#printDriverName');
    if (printDriverNameElement) printDriverNameElement.classList.remove('d-none');
    document.getElementById('driver-wage-details-print')?.click();
  }
  this.setState({ isDownloadLoadingPdf: false });
  }
  render() {
    return (
      <div>
        {this.renderDriverInvoice(this.setComponentRef)}
      </div>
    );
  }
}
